import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'
import PropTypes from 'prop-types'

const Confirmation = ({ onConfirm, message }) => (
  <Popup title={I18n.t('publisher.dashboard.export_results')} onClose={() => {}}>
    <Body>
      {message || I18n.t('publisher.dashboard.export_results_expiration_info')}
    </Body>
    <Footer>
      <Button onClick={onConfirm}>
        {I18n.t('publisher.action.okay')}
      </Button>
    </Footer>
  </Popup>
)

Confirmation.propTypes = {
  message: PropTypes.string,
  onConfirm: PropTypes.func.isRequired
}

export default Confirmation
